// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @box/platform/no-enums
export enum NativeMessagingVersion {
  One = 1, // Original implementation
  Latest = One,
}
